import { Box, Card, CardContent, Grid, Typography } from "@mui/material";
import { 
    Calculate, 
    Clear, 
    Download, 
    Grading, 
    RestartAlt, 
    Search, 
    AssignmentReturnOutlined,
    ArrowBack 
} from "@mui/icons-material";
import {
    GridActionsCellItem,
    GridRowId,
    GridRowModel,
    GridRowParams,
    GridSortDirection,
    GridSortModel,
} from "@mui/x-data-grid";
import { useEffect, useMemo, useState } from "react";

import AutoComplete from "../../../components/hookForms/autoComplete";
import { Button } from "@mui/material";
import ConfirmationDialog from "../../../components/confirmationDialog";
import { Container } from "../../../theme/globalStyles";
import DataTable from "../../../components/dataTable";
import DialogFaturarPrevisto from "./modal/dialogFaturarPrevisto";
import DialogReopen from "./modal/dialogReopen";
/* eslint-disable react-hooks/exhaustive-deps */
import IGenericResult from "../../../interfaces/IGenericResult";
import InputNumber from "../../../components/hookForms/inputNumber";
import Tooltip from "@mui/material/Tooltip";
import { makeStyles } from "@mui/styles";
import messages from "../../../utils/messages";
import { s3download } from "../../../utils/s3";
import serviceClienteInstalacao from "../../../services/serviceClienteInstalacao";
import serviceFaturaConcessionaria from "../../../services/serviceFaturaConcessionaria";
import serviceFaturaInstalacao from "../../../services/serviceFaturaInstalacao";
import serviceFaturaPrevista from "../../../services/serviceFaturaPrevista";
import serviceUsina from "../../../services/serviceUsina";
import { toast } from "react-toastify";
import { useAuth } from "../../../context/global";
import { useForm } from "react-hook-form";
import DatePickerMui from "../../../components/hookForms/datePicker";
import { format, parse } from "date-fns";
import { useHistory } from "react-router-dom";

const FaturaPrevista = (props: any) => {
    const { setTitlePage } = useAuth();

    useEffect(() => {
        setTitlePage("Faturamento Geral - Faturas Previstas");
    }, [setTitlePage]);

    const [showBackOptions, setShowBackOptions] = useState(false);

    const filterOld = props?.location?.state?.filterOld || "";
    const rotaAnterior = props?.location?.state?.rotaAnterior || "";

    const history = useHistory();    
    const [data, setData] = useState<any[]>([]);
    const [pageSize, setPageSize] = useState(100);
    const [page, setPage] = useState(0);
    const [filters, setFilters] = useState(null);
    const [rowCount, setRowCount] = useState(0);
    const [isLoading, setLoading] = useState(false);
    const [buttonSelected, setButtonSelected] = useState<any[]>(["Aberta"]);
    const [usinaDataOptions, setUsinaDataOptions] = useState<IGenericResult[]>([]);
    const classes = useStyles();
    const [disableButtonPostergar, setDisableButtonPostergar] = useState<number>(0);
    const [reopen, setReopen] = useState(false);
    const [valueId, setValueId] = useState<any>();
    const { handleGetDataUser } = useAuth();
    const user = handleGetDataUser();

    const isMasterOrAdmin = user.perfil === "Master" || user.perfil === "Admin";

    const [sortModel, setSortModel] = useState<GridSortModel>([
        {
            field: "",
            sort: "" as GridSortDirection,
        },
    ]);

    const [faturarPrevistoState, setFaturarPrevistoState] = useState({
        open: false,
        idFaturaPrevista: "",
        numeroInstalacao: "",
        ciclo: "",
        regraFatura: "",
    });

    const [gerarFaturaState, setGerarFaturaState] = useState({ 
        idFaturaConcessionaria: "", 
        idFaturaPrevista: "",
        open: false 
    });

    const [postergarFaturaState, setPostergarFaturaState] = useState({ data: "", open: false });

    const {
        control,
        handleSubmit,
        reset,
        formState: { errors },
        // eslint-disable-next-line react-hooks/rules-of-hooks
    } = useForm({
        defaultValues: {
            diasAtrasoInicial: "",
            diasAtrasoFinal: "",
            usinaID: 0,
            numeroInstalacao: "",
            statusFaturaPrevista: "Aberta",
            cicloFaturamento: null, //tbm vem por parâmetro quando tela acionada via "Fatura de Usinas"
        },
    });

    const actionColumns = useMemo(
        () => [
            {
                headerName: "Operações",
                field: "operations",
                type: "actions",
                width: 200,
                hide: false,
                getActions: (params: { id: GridRowId; row: GridRowModel }) => [
                    <GridActionsCellItem
                        icon={
                            <Tooltip title="Fatura da Concessionária">
                                <Download />
                            </Tooltip>
                        }
                        label="Fatura da Concessionária"
                        onClick={() => {                           
                            s3download("prebilling-faturas-previsto", `exemplo.pdf`);
                        }}
                    />,
                    <GridActionsCellItem
                        icon={
                            <Tooltip title="Faturar pelo Previsto">
                                <Grading />
                            </Tooltip>
                        }
                        label="Faturar pelo Previsto"
                        onClick={() => {
                            onClickFaturarPrevisto(
                                params.row.numeroInstalacao,
                                params.row.cicloFaturamento,
                                params.id.toString()
                            );
                        }}
                        disabled={params.row.statusFaturaPrevista !== "Aberta"}
                    />,
                    <GridActionsCellItem
                        icon={
                            <Tooltip title="Gerar Fatura">
                                <Calculate />
                            </Tooltip>
                        }
                        label="Gerar Fatura"
                        onClick={() => {
                            onClickGerarFatura(params.row.numeroInstalacao, params.row.cicloFaturamento, params.id.toString());
                        }}
                        disabled={params.row.statusFaturaPrevista !== "Aberta"}
                    />,
                    <GridActionsCellItem
                        icon={
                            <Tooltip title="Postergar Fatura">
                                <RestartAlt />
                            </Tooltip>
                        }
                        label="Postergar Fatura"
                        onClick={() => {
                            setDisableButtonPostergar(Number(params.id));
                            setPostergarFaturaState({ data: params.id.toString(), open: true });
                        }}
                        disabled={params.row.statusFaturaPrevista !== "Aberta" || params.id === disableButtonPostergar}
                    />,
                    <GridActionsCellItem
                        icon={
                            <Tooltip title="Reabrir">
                                <AssignmentReturnOutlined />
                            </Tooltip>
                        }
                        label="Reabrir"
                        onClick={() => handleReopen(params.id, params.row.numeroInstalacao, params.row.cicloFaturamento)}
                        disabled={!isMasterOrAdmin || params.row.statusFaturaPrevista !== "Adiada"}
                    />,
                ],
            },
        ],
        [disableButtonPostergar]
    );

    const columns = useMemo(
        () => [
            {
                headerName: "ID",
                field: "faturaPrevistaID",
                type: "number",
                headerAlign: "left",
                identity: true,
                width: 90,
            },
            {
                headerName: "Instalação",
                field: "numeroInstalacao",
                type: "string",
                width: 180,
            },
            {
                headerName: "Usina",
                field: "nomeUsina",
                type: "string",
                width: 250,
            },
            {
                headerName: "Ciclo",
                field: "cicloFaturamento",
                type: "string",
                width: 100,
            },
            {
                headerName: "Última fatura",
                field: "dataUltimaFatura",
                type: "date",
                width: 130,
            },
            {
                headerName: "Qtd Prevista",
                field: "quantidadePrevista",
                type: "number",
                headerAlign: "left",
                width: 140,
            },
            {
                headerName: "Consumo kWh",
                field: "consumoPrevisto",
                type: "number",
                headerAlign: "left",
                width: 150,
            },
            {
                headerName: "Status",
                field: "statusFaturaPrevista",
                type: "string",
                width: 100,
            },
            {
                headerName: "% Previsto",
                field: "percentualPrevisto",
                type: "number",
                headerAlign: "left",
                width: 120,
            },
            {
                headerName: "Atraso",
                field: "quantidadeDiasAtraso",
                type: "string",
                width: 80,
            },
            ...actionColumns,
        ],
        [actionColumns]
    );

    useEffect(() => {
        setUsinaData();
    }, []);

    const setUsinaData = async () => {
        await serviceUsina
            .getUsinas()
            .then((result) => {
                setUsinaDataOptions(result?.data);
            })
            .catch(() => {
                setUsinaDataOptions([]);
            });
    };

    const onClickFaturarPrevisto = async (numeroInstalacao: any, cicloFaturamento: any, idFaturaPrevista: any) => {
        setLoading(true);

        if (numeroInstalacao) {
            const filtersInstalacao = {
                numeroInstalacao: numeroInstalacao,
                flagHabilitado: "Sim",
            };

            serviceClienteInstalacao
                .getWithFilter({ ...filtersInstalacao })
                .then((result) => {
                    let regraFatura = "";

                    if (result?.data.content && result?.data.content.length > 0) {
                        regraFatura = result?.data.content[0].tipoFaturaPrevista;

                        if (regraFatura === "Previsto injetado") {
                            regraFatura = "Fatura Prevista Injetado";
                        } else if (regraFatura === "Previsto consumo") {
                            regraFatura = "Fatura Prevista Consumo";
                        }
                    }

                    setFaturarPrevistoState({
                        open: true,
                        idFaturaPrevista: idFaturaPrevista,
                        numeroInstalacao: numeroInstalacao,
                        ciclo: cicloFaturamento,
                        regraFatura: regraFatura,
                    });
                })
                .catch((err) => {
                    toast.error("Erro ao obter a instalação do cliente", err);
                })
                .finally(() => {
                    setLoading(false);
                });
        }
    };

    const onClickGerarFatura = async (numeroInstalacao: any, cicloFaturamento: any, idFaturaPrevista: any) => {
        setLoading(true);

        if (numeroInstalacao && cicloFaturamento) {
            const filtersFaturaConcessionaria = {
                numeroInstalacao: numeroInstalacao,
                cicloFaturamento: cicloFaturamento,
                flagExcluidaCalculo: "Não",
            };

            serviceFaturaConcessionaria
                .getWithFilter({ ...filtersFaturaConcessionaria })
                .then((result) => {
                    let faturaConcessionariaID = "";

                    if (result?.data.content && result?.data.content.length > 0) {
                        faturaConcessionariaID =
                            result?.data.content[result?.data.content.length - 1].faturaConcessionariaID;

                        setGerarFaturaState({ 
                            idFaturaConcessionaria: faturaConcessionariaID.toString(), 
                            idFaturaPrevista: idFaturaPrevista.toString(),
                            open: true 
                        });
                    } else {
                        toast.error(
                            "Fatura de Concessionária não encontrada para instalação " +
                                filtersFaturaConcessionaria.numeroInstalacao +
                                " - Ciclo " +
                                filtersFaturaConcessionaria.cicloFaturamento
                        );
                    }
                })
                .finally(() => {
                    setLoading(false);
                });
        }
    };

    const statusOptions = [
        { label: "Aberta", value: "Aberta" },
        { label: "Adiada", value: "Adiada" },
        { label: "Processada", value: "Processada" },
        { label: "Aprovada", value: "Aprovado" },
    ];

    const getAllWithFilters = async (filters: any) => {
        setData([]);
        setLoading(true);

        if (!filters) {
            filters = { statusFaturaPrevista: "Aberta" };
        }

        await serviceFaturaPrevista
            .getWithFilter({
                ...filters,
                take: pageSize,
                currentPage: page + 1,
                sortExpression: sortModel[0]?.field ?? "",
                sortDirection: sortModel[0]?.sort ?? "",
            })
            .then((result) => {
                setData(result?.data.content);
                setRowCount(result?.data.numberOfElements);
            })
            .catch((err) => {
                toast.error(messages.getWithFilterError, err);
                setData([]);
                setRowCount(0);
            })
            .finally(() => {
                setLoading(false);
            });
    };

    useEffect(
        () => {
            if (props && props.location && props.location.state) {
                getAllWithFilters(props.location.state);
                setButtonSelected(["Aberta,Adiada,Processada,Aprovado"]);
            } else {
                getAllWithFilters(filters);
            }
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [page, pageSize, sortModel]
    );

    const handlePostergar = async () => {
        if(!isLoading){
            setLoading(true);

            await serviceFaturaPrevista
                .Postergar(Number(postergarFaturaState.data))
                .then((result) => {
                    if (result) {
                        toast.success("Fatura postergada com sucesso!");
                    }
                })
                .catch((err) => {
                    toast.error("Ocorreu um erro e a fatura não foi postergada!", err);
                })
                .finally(() => {
                    setLoading(false);
                    setPostergarFaturaState({ data: "", open: false });
                    setDisableButtonPostergar(0);
                    getAllWithFilters(filters);
                });
        }
    };

    const handleGerarFatura = async () => {
        setLoading(true);

        const gerarFaturaValues = {
            idFaturaConcessionaria: Number(gerarFaturaState.idFaturaConcessionaria),
            idFaturaPrevista: Number(gerarFaturaState.idFaturaPrevista),
        };

        serviceFaturaInstalacao
            .createByFaturaConcessionaria(gerarFaturaValues)
            .then((result) => {
                if (result) {
                    toast.success("Fatura de Instalação gerada com sucesso. ID: " + result.data.faturaInstalacaoID);
                }
            })
            .finally(() => {
                setLoading(false);
                getAllWithFilters(filters);
            });
    };

    const onSubmit = (values: any) => {
        const filters = {
            ...values,
            statusFaturaPrevista: buttonSelected.join(","),
            cicloFaturamento: values.cicloFaturamento ? format(values.cicloFaturamento, "MM/yyyy") : "",
        };

        setFilters(filters);
        getAllWithFilters(filters);
    };

    useEffect(() => {
        if (props && props.location && props.location.state) {
            reset(props.location.state);
            setFilters(props.location.state);
            getAllWithFilters(props.location.state);
            setShowBackOptions(true);
        }
    }, [props]);

    const onClear = () => {
        setButtonSelected(["Aberta"]);

        reset({
            diasAtrasoInicial: "",
            diasAtrasoFinal: "",
            usinaID: 0,
            numeroInstalacao: "",
            statusFaturaPrevista: "Aberta",
            cicloFaturamento: null,
        });

        setFilters(null);
        getAllWithFilters(null);
        setShowBackOptions(false);
    };

    const onSuccessAction = () => {
        getAllWithFilters(filters);
    };

    const clearGerarFaturaState = () => {
        setGerarFaturaState({ 
            idFaturaConcessionaria: "", 
            idFaturaPrevista: "",
            open: false 
        });
    }

    const handleReopen = (id: any, numeroInstalacao: any, cicloFaturamento: any) => {       
        setReopen(true);
        setValueId({ id, numeroInstalacao, cicloFaturamento });
    };

    return (
        <Container>
            <Card>
                <CardContent>
                    <Box sx={{ mb: 2 }}>
                        <form onSubmit={handleSubmit(onSubmit)}>        

                            {(showBackOptions && rotaAnterior) &&
                                (
                                <Grid container spacing={2} display="flex" alignItems="left">
                                    <Grid item md={2}>
                                        <Button
                                            disableElevation
                                            variant="text"
                                            color="primary"
                                            fullWidth
                                            style={{ margin: "16px 0px 8px 0px" }}
                                            startIcon={<ArrowBack />}
                                            onClick={() => {
 
                                                history.push(rotaAnterior, {
                                                    ...filterOld,  
                                                    cicloFaturamento: filterOld.cicloFaturamento 
                                                    && filterOld.cicloFaturamento.length === 7 ? 
                                                        parse(("01/" + filterOld.cicloFaturamento), "dd/MM/yyyy", new Date()) 
                                                        : filterOld.cicloFaturamento ?? "",   
                                                    dataEmissao: filterOld.dataEmissao ?
                                                            (filterOld.dataEmissao.length !== 10 ? 
                                                                filterOld.dataEmissao 
                                                                : parse(filterOld.dataEmissao, "dd/MM/yyyy", new Date()))
                                                             : ""                                    
                                                });
                                            }}
                                        >
                                            Voltar
                                        </Button>
                                    </Grid>
                                </Grid>
                            )}

                            <Grid container spacing={2} display="flex" alignItems="center">                               
                                <Grid item xs={12} md={2}>
                                    <DatePickerMui
                                        name="cicloFaturamento"
                                        label="Ciclo"
                                        format="MM/yyyy"
                                        view={["month", "year"]}
                                        control={control}
                                        error={errors}
                                    />
                                </Grid>

                                <Grid item xs={12} md={2}>
                                    <InputNumber
                                        name="numeroInstalacao"
                                        label="Instalação"
                                        control={control}
                                        error={errors}
                                        decimalScale={0}
                                        noThousandSeparator
                                        maxLength={15}
                                    />
                                </Grid>

                                <Grid item xs={12} md={3}>
                                    <AutoComplete
                                        name="usinaID"
                                        label="Nome da usina"
                                        options={usinaDataOptions}
                                        control={control}
                                        error={errors}
                                    />
                                </Grid>

                                <Grid
                                    item
                                    xs={1}
                                    md={1}
                                    display="flex"
                                    alignItems="center"
                                    justifyContent="flex-end"
                                >
                                    <Typography sx={{ mt: "14px" }}>Atraso</Typography>
                                </Grid>

                                <Grid item xs={12} md={1}>
                                    <InputNumber
                                        name="diasAtrasoInicial"
                                        label="De"
                                        allowNegative
                                        control={control}
                                        error={errors}
                                    />
                                </Grid>
                                
                                <Grid item xs={12} md={1}>
                                    <InputNumber
                                        name="diasAtrasoFinal"
                                        label="Até"
                                        allowNegative
                                        control={control}
                                        error={errors}
                                    />
                                </Grid>

                                <Grid item md={2}>
                                    <Button
                                        variant="contained"
                                        fullWidth
                                        color="warning"
                                        style={{ margin: "16px 0px 8px 0px" }}
                                        startIcon={<Search />}
                                        type="submit"
                                        disabled={isLoading}
                                        disableElevation
                                    >
                                        Pesquisar
                                    </Button>
                                </Grid>
                            </Grid>

                            <Grid container spacing={2}>
                                <Grid item xs={12} md={10} sx={{ mt: 2 }}>
                                <Typography variant="subtitle2" color="#5B5B5F">
                                        Status:
                                        {statusOptions.map((item, index) => {
                                            return (
                                                <Button
                                                    key={index}
                                                    variant={
                                                        buttonSelected.includes(item.value) ? "contained" : "outlined"
                                                    }
                                                    color="warning"
                                                    size="small"
                                                    disableElevation
                                                    onClick={() => {
                                                        setButtonSelected((oldstate) => {
                                                            if (oldstate.includes(item.value)) {
                                                                return oldstate.filter((e) => e !== item.value);
                                                            } else {
                                                                return [...oldstate, item.value];
                                                            }
                                                        });
                                                    }}
                                                    style={{ margin: "0px 12px", minWidth: "150px", height: "33px" }}
                                                >
                                                    {item.label}
                                                </Button>
                                            );
                                        })}
                                    </Typography>
                                </Grid>
                                <Grid item xs={12} md={2} display="flex" justifyContent="flex-start">
                                    <Button
                                        style={{ margin: "16px 0px 8px 0px" }}
                                        variant="outlined"
                                        color="warning"
                                        startIcon={<Clear />}
                                        onClick={() => onClear()}
                                        disableElevation
                                        fullWidth
                                        size="small"
                                    >
                                        Limpar
                                    </Button>
                                </Grid>
                            </Grid>
                        </form>
                    </Box>
                
                    <Box style={{ height: "600px" }}>
                        <DataTable
                            columns={columns}
                            rows={data}
                            rowId={(row: GridRowModel) => row.faturaPrevistaID}
                            rowCount={rowCount}
                            isLoading={isLoading}
                            onPageChange={(currentPage: number) => setPage(currentPage)}
                            onPageSizeChange={(currentPageSize: number) => setPageSize(currentPageSize)}
                            pageSize={pageSize}
                            getRowClassName={(params: GridRowParams<GridRowModel>) => {
                                // let status = params.getValue("status");
                                if (
                                    params.row.quantidadeDiasAtraso === "0" ||
                                    params.row.quantidadeDiasAtraso === "1"
                                ) {
                                    return classes.injecaoAcimaEsperado;
                                }
                                if (params.row.quantidadeDiasAtraso < 1) {
                                    return classes.comDivergencia;
                                }
                            }}
                            onSortModelChange={(model: GridSortModel) => setSortModel(model)}
                        />
                    </Box>

                    <DialogFaturarPrevisto
                        open={faturarPrevistoState.open}
                        onSuccess={() => onSuccessAction()}
                        data={{
                            idFaturaPrevista: faturarPrevistoState.idFaturaPrevista,
                            numeroInstalacao: faturarPrevistoState.numeroInstalacao,
                            ciclo: faturarPrevistoState.ciclo,
                            regraFatura: faturarPrevistoState.regraFatura,
                        }}
                        onClose={() => {
                            setFaturarPrevistoState({
                                open: false,
                                idFaturaPrevista: "",
                                numeroInstalacao: "",
                                ciclo: "",
                                regraFatura: "",
                            });
                        }}
                    />

                    <ConfirmationDialog
                        open={gerarFaturaState?.open}
                        title={"Gerar Fatura"}
                        message={"Deseja realmente gerar a Fatura de Instalação para esta Fatura Prevista?"}
                        cancelButtonText={"Não"}
                        confirmButtonText={"Sim"}
                        onClose={() => clearGerarFaturaState()}
                        onCancel={() => clearGerarFaturaState()}
                        onConfirm={() => {           
                            clearGerarFaturaState();               
                            handleGerarFatura();
                        }}
                    />

                    <ConfirmationDialog
                        open={postergarFaturaState?.open}
                        title={"Postergar Fatura"}
                        message={"Deseja realmente postergar esta Fatura Prevista?"}
                        cancelButtonText={"Não"}
                        confirmButtonText={"Sim"}
                        onClose={() => {
                            setPostergarFaturaState({ data: "", open: false });
                            setDisableButtonPostergar(0);
                        }}
                        onCancel={() => {
                            setPostergarFaturaState({ data: "", open: false });
                            setDisableButtonPostergar(0);
                        }}
                        onConfirm={() => {
                            setPostergarFaturaState({ data: "", open: false });
                            handlePostergar();
                        }}
                    />

                    <DialogReopen
                        open={reopen}
                        idProp={valueId}
                        onClose={() => {
                            setReopen(false);
                            getAllWithFilters(filters);
                        }}
                        onCancel={() => {
                            setReopen(false);
                        }}
                    />
                </CardContent>
            </Card>
        </Container>
    );
};

const useStyles = makeStyles({
    injecaoAcimaEsperado: {
        backgroundColor: "#F7F6D1",
        "&:hover": {
            backgroundColor: "#edeb9b !important",
        },
    },
    naoFaturadoConcessionaria: {
        backgroundColor: "#D1E8F7",
        "&:hover": {
            backgroundColor: "#a3d1ef !important",
        },
    },
    injecaoMaiorQueConsumo: {
        backgroundColor: "#a54cf975",
        "&:hover": {
            backgroundColor: "#962ff8 !important",
        },
    },
    comDivergencia: {
        backgroundColor: "#F7D1D1",
        "&:hover": {
            backgroundColor: "#efa3a3 !important",
        },
    },
});

export default FaturaPrevista;
